module.exports = __webpack_public_path__ + "media/images/emblems/Reute-8ab81aac0b1d1d6f7b097d9f3d6a4479.png";